import {
	SYS_BORDER_RADIUS_MD,
	SYS_BREAKPOINT_MD,
	SYS_SPACE_FIXED_100,
	SYS_SPACE_FIXED_150,
	SYS_SPACE_FIXED_200,
	SYS_SPACE_FIXED_350,
} from '@oneaudi/unified-web-alpha-common';
import styled from 'styled-components';
import { breakPoints, customBreakPoint, mobileBreakPoint } from '~/styles/break-points';

type GalleryStyleProps = { $aspectRatio?: string; $objectPosition?: string; $isPhoneOrTablet?: boolean | number };

export const GalleryStyle = styled.div<GalleryStyleProps>`
	position: relative;
	min-width: 0;
	height: max-content;
	border-radius: ${SYS_BORDER_RADIUS_MD};
	overflow: hidden;

	picture {
		display: contents;
	}

	img,
	video {
		// only used on summary page right now
		aspect-ratio: ${(props) => (props.$aspectRatio ? `${props.$aspectRatio} !important` : 'inherit')};
		object-position: ${(props) => (props.$objectPosition ? `${props.$objectPosition}` : 'inherit')};
		height: 100%;
		width: 100%;
	}

	.control-button {
		z-index: 8;

		&.close-fullscreen {
			position: absolute;
			top: 12px;
			right: 12px;
		}
	}
	.gallery-controls {
		padding: ${SYS_SPACE_FIXED_200} ${SYS_SPACE_FIXED_150};
		display: flex;
		justify-content: space-between;
	}

	.controls-left,
	.controls-right {
		display: flex;
		gap: ${SYS_SPACE_FIXED_100};
	}

	.controls-right {
		margin-left: auto;
	}

	.close-avp {
		position: absolute;
		top: 12px;
		right: 12px;
	}

	.swiper-reset {
		pointer-events: none;
		${(props) =>
			breakPoints({
				'1024': `
				img {
				    // We need pointer events auto to enable copying images on desktop
					${!props.$isPhoneOrTablet ? 'pointer-events: auto;' : ''}
				}
			`,
			})}
	}

	@media screen and (min-width: ${SYS_BREAKPOINT_MD}) {
		.gallery-controls {
			padding: 0 ${SYS_SPACE_FIXED_350} ${SYS_SPACE_FIXED_350} ${SYS_SPACE_FIXED_350};
			position: absolute;
			bottom: 0;
			left: 0;
			right: 0;
		}
	}
`;

export const GalleryItemDefaultStyle = styled.div<{ $aspectRatio?: string }>`
	display: flex;
	height: 100%;
	width: 100%;

	> div {
		width: 100%;
	}

	img,
	video {
		aspect-ratio: 4 / 3;
		object-fit: cover;

		${(props) =>
			`${customBreakPoint(
				mobileBreakPoint,
				`
				aspect-ratio: ${props.$aspectRatio} !important;
			`,
			)}`}
	}
`;

export const GalleryItem2Style = styled.div`
	display: flex;
	height: 100%;
	width: 100%;

	.left-side {
		display: flex;
		aspect-ratio: 4 / 3;

		img,
		video {
			flex: 1;
			aspect-ratio: 4 / 3;
			object-fit: cover;
		}
	}

	.right-side {
		display: flex;
		flex: 1;
		height: 100%;
		min-width: 0;

		img,
		video {
			flex: 1;
			object-fit: cover;
			aspect-ratio: 2 / 3;
		}
	}
`;

export const GalleryItem3Style = styled.div`
	display: flex;
	height: 100%;
	width: 100%;

	.left-side {
		display: flex;
		aspect-ratio: 4 / 3;

		img,
		video {
			flex: 1;
			aspect-ratio: 4 / 3;
			object-fit: cover;
		}
	}

	.right-side {
		display: flex;
		flex-direction: column;
		aspect-ratio: 2 / 3;

		img,
		video {
			flex: 1;
			object-fit: cover;
		}
	}
`;

export const SpacingContainerStyles = styled.div<{
	$placed: 'top' | 'bottom' | 'left' | 'right';
	$aspectRatio?: string;
	$flex?: string;
}>`
	position: relative;
	display: flex;
	flex-direction: column;
	box-sizing: border-box;
	border: 0;
	width: 100%;
	flex: ${(props) => props.$flex || 1};
	aspect-ratio: ${(props) => props.$aspectRatio || 1};
	height: max-content;

	${(props) => (props.$placed === 'top' ? 'border-top: 4px solid transparent' : '')}
	${(props) => (props.$placed === 'bottom' ? 'border-bottom: 4px solid transparent' : '')}
	${(props) => (props.$placed === 'right' ? 'border-right: 4px solid transparent' : '')}
	${(props) => (props.$placed === 'left' ? 'border-left: 4px solid transparent' : '')}
`;
